import i18next from 'i18next';
import React from 'react';

import {
  GENERIC_MODAL_CANCEL_BUTTON,
  GENERIC_MODAL_SAVE_BUTTON,
} from '@commons/Modals/GenericModal/genericModalActions';
import InputContentModal from '@commons/Modals/InputContentModal';

export const getParamsModal = ({
  inputValue,
  closeCleanUp,
  errorMessage,
  setValue,
  handleSave,
}) => ({
  type: 'action',
  width: '560px',
  height: 'auto',
  icon: '/images/inpulse/pen-black-small.svg',
  title: i18next.t('AGENT.AGENT.EDIT_CONVERSATION_NAME_MODAL_TITLE'),
  handleCloseCleanUp: closeCleanUp,
  component: () => (
    <InputContentModal
      errorMessage={errorMessage}
      label={i18next.t('AGENT.AGENT.EDIT_CONVERSATION_NAME_INPUT_LABEL')}
      value={inputValue}
      autoFocus
      onChange={(value) => setValue(value)}
    />
  ),
  actions: [
    GENERIC_MODAL_CANCEL_BUTTON(),
    {
      ...GENERIC_MODAL_SAVE_BUTTON(),
      isDisabled: !inputValue.trim() || !!errorMessage,
      handleClick: handleSave,
    },
  ],
});
